import { lazy } from 'react';
import { t } from 'helpers/i18n';
import {
  ApolloIcon,
  AppConfigIcon,
  BoxIcon,
  ExtensionsIcon,
  LoginConfigIcon,
  LoyaltyIcon,
  NotificationIcon,
  PaymentControllerIcon,
  PaymentIcon,
  TrackingConfigIcon,
} from '../Icons';
import { IRouteV2 } from '../../../data';

// Project detail pages
const ProjectConfigView = lazy(() =>
  import('v2/containers/ProjectDetail/ProjectConfig/ProjectConfigView')
);
const LoginConfigView = lazy(() =>
  import('v2/containers/ProjectDetail/LoginConfig/LoginConfigView')
);
const ApolloConfigView = lazy(() =>
  import('v2/containers/ProjectDetail/ApolloConfig/ApolloConfigView')
);
const PaymentConfigView = lazy(() =>
  import('v2/containers/ProjectDetail/PaymentConfig/PaymentConfigView')
);
const LoyaltyConfigView = lazy(() =>
  import('v2/containers/ProjectDetail/LoyaltyConfig/LoyaltyConfigView')
);
const TrackingConfigView = lazy(() =>
  import('v2/containers/ProjectDetail/TrackingConfig/TrackingConfigView')
);
const NotificationConfigView = lazy(() =>
  import(
    'v2/containers/ProjectDetail/NotificationConfig/NotificationConfigView'
  )
);
const BuildAndReleaseConfigView = lazy(() =>
  import(
    'v2/containers/ProjectDetail/BuildAndRelease/BuildAndReleaseConfigView'
  )
);
const ExtensionsView = lazy(() =>
  import('v2/containers/ProjectDetail/Extensions/ExtensionsView')
);
const ControllerConfigView = lazy(() =>
  import('v2/containers/ProjectDetail/PaymentController/ControllerConfigView')
);

const appConfigRoute: IRouteV2 = {
  exact: true,
  path: `/v2/projects/:projectId/app-config`,
  name: t('project_config_title'),
  component: ProjectConfigView,
  icon: AppConfigIcon,
  //permissions: [permission(TERRA, APP, READ)],
};

const loginConfigRoute: IRouteV2 = {
  exact: true,
  path: `/v2/projects/:projectId/login-config`,
  name: t('login_config_menu'),
  component: LoginConfigView,
  icon: LoginConfigIcon,
  //permissions: [permission(TERRA, APP, READ)],
};

const apolloConfigRoute: IRouteV2 = {
  exact: true,
  path: `/v2/projects/:projectId/apollo-config`,
  name: t('apollo_config_menu'),
  component: ApolloConfigView,
  icon: ApolloIcon,
};

const paymentConfigRoute: IRouteV2 = {
  exact: true,
  path: `/v2/projects/:projectId/payment-config`,
  name: t('Payment'),
  component: PaymentConfigView,
  icon: PaymentIcon,
  //permissions: [permission(TERRA, APP, READ)],
};

const loyaltyConfigRoute: IRouteV2 = {
  exact: true,
  path: `/v2/projects/:projectId/loyalty-config`,
  name: t('Loyalty'),
  component: LoyaltyConfigView,
  icon: LoyaltyIcon,
  //permissions: [permission(TERRA, APP, READ)],
};

const notificationConfigRoute: IRouteV2 = {
  exact: true,
  path: `/v2/projects/:projectId/notification-config`,
  name: t('notification_sidebar_title'),
  component: NotificationConfigView,
  icon: NotificationIcon,
  //permissions: [permission(TERRA, APP, READ)],
};

const buildAndReleaseConfigRoute: IRouteV2 = {
  exact: true,
  path: `/v2/projects/:projectId/build-and-release`,
  name: t('build_and_release_sidebar_title'),
  component: BuildAndReleaseConfigView,
  icon: BoxIcon,
  //permissions: [permission(TERRA, APP, READ)],
};

const trackingConfigRoute: IRouteV2 = {
  exact: true,
  path: `/v2/projects/:projectId/tracking-config`,
  name: t('Tracking'),
  component: TrackingConfigView,
  icon: TrackingConfigIcon,
  //permissions: [permission(TERRA, APP, READ)],
};

const controllerConfigRoute: IRouteV2 = {
  exact: true,
  path: `/v2/projects/:projectId/payment-controller`,
  name: t('payment_controller_header'),
  component: ControllerConfigView,
  icon: PaymentControllerIcon,
  //permissions: [permission(TERRA, APP, READ)],
};

const extensionsConfigRoute: IRouteV2 = {
  exact: true,
  path: `/v2/projects/:projectId/extensions`,
  name: t('extensions'),
  icon: ExtensionsIcon,
  component: ExtensionsView,
  subMenu: [controllerConfigRoute],
  //permissions: [permission(TERRA, APP, READ)],
};

const routes: IRouteV2[] = [
  appConfigRoute,
  loginConfigRoute,
  paymentConfigRoute,
  loyaltyConfigRoute,
  notificationConfigRoute,
  trackingConfigRoute,
  apolloConfigRoute,
  buildAndReleaseConfigRoute,
  extensionsConfigRoute,
];

export default routes;
